'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getFeatures = getFeatures;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_FEATURES = 'redux/features/GET_FEATURES';
var GET_FEATURES_SUCCESS = 'redux/features/GET_FEATURES_SUCCESS';
var GET_FEATURES_FAIL = 'redux/features/GET_FEATURES_FAIL';

var initialState = {
  features: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GET_FEATURES:
      return (0, _extends3.default)({}, state, {
        gettingFeatures: true
      });
    case GET_FEATURES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        gettingFeatures: false,
        features: action.result.obj.features
      });
    case GET_FEATURES_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingFeatures: false,
        getFeaturesError: action.error.errObj
      });
    default:
      return state;
  }
}

function getFeatures(supportedFeatures, operatorId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [GET_FEATURES, GET_FEATURES_SUCCESS, GET_FEATURES_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.appFeatures.features({
            supportedFeatures: supportedFeatures,
            sessionId: auth.sessionId,
            operatorId: operatorId,
            languageTag: auth.lang,
            clientId: auth.clientId,
            feVersion: getState().appInfo.version
          }, { responseContentType: 'application/json' }).then(function (result) {
            return result;
          });
        });
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/features.js
// module id = 2039
// module chunks = 0